export const dict = {
    ins_prenom: {
        required: 'Veuillez renseigner votre prénom.',
    },
    prenom: {
        required: 'Veuillez renseigner un prénom.',
    },
    ins_nom: {
        required: 'Veuillez renseigner votre nom.',
    },
    nom: {
        required: 'Veuillez renseigner un nom.',
    },
    name: {
        required: 'Veuillez renseigner un nom.',
    },
    ins_email: {
        required: 'Veuillez entrer votre adresse email.',
        email: 'Veuillez renseigner une adresse mail valide.'
    },
    email: {
        required: 'Veuillez entrer une adresse email.',
        email: 'Veuillez renseigner une adresse mail valide.'
    },
    password: {
        required: 'Veuillez renseigner le mot de passe.',
        confirmed: 'Le mot de passe et sa confirmation ne correspondent pas.'
    },
    password_confirmation: {
        required: 'Veuillez renseigner la confirmation du mot de passe.',
    },
    phone: {
        required: 'Veuillez renseigner un numéro de téléphone.'
    },
    ins_tel: {
        required: 'Veuillez renseigner un numéro de téléphone.'
    },
    ins_port: {
        required: 'Veuillez renseigner un numéro de mobile.'
    },
    optin_email: {
        required: 'Vous devez accepter ce champ.'
    },
    address: {
        required: 'Veuillez saisir une adresse.'
    },
    cp: {
        required: 'Veuillez saisir un code postal.'
    },
    zipcode: {
        required: 'Veuillez saisir un code postal.'
    },
    search: {
        required: 'Veuillez renseigner une localité ou un code postal valide.'
    },
    city: {
        required: 'Veuillez saisir une ville.'
    },
    country: {
        required: 'Veuillez saisir un pays.'
    },
    agency: {
        required: 'Vous devez sélectionner une agence.'
    },
    optin_rules: {
        required: 'Vous devez accepter le règlement.'
    },
    reward: {
        required: 'Vous devez sélectionner un type de récompense.'
    },
    mechanics: {
        required: 'Vous devez sélectionner au moins un domaine'
    },
    nature: {
        required: 'Vous devez sélectionner la nature de votre demande.'
    },
    demande: {
        required: 'Vous devez formuler votre demande.'
    },
    minPalier0: {
        required: 'Vous devez saisir un montant.'
    },
    minPalier1: {
        required: 'Vous devez saisir un montant.'
    },
    minPalier2: {
        required: 'Vous devez saisir un montant.'
    },
    minPalier3: {
        required: 'Vous devez saisir un montant.'
    },
    minPalier4: {
        required: 'Vous devez saisir un montant.'
    },
    maxPalier0: {
        required: 'Vous devez saisir un montant.'
    },
    maxPalier1: {
        required: 'Vous devez saisir un montant.'
    },
    maxPalier2: {
        required: 'Vous devez saisir un montant.'
    },
    maxPalier3: {
        required: 'Vous devez saisir un montant.'
    },
    maxPalier4: {
        required: 'Vous devez saisir un montant.'
    },
    recompenseFilleul0: {
        required: 'Vous devez saisir un montant.'
    },
    recompenseFilleul1: {
        required: 'Vous devez saisir un montant.'
    },
    recompenseFilleul2: {
        required: 'Vous devez saisir un montant.'
    },
    recompenseFilleul3: {
        required: 'Vous devez saisir un montant.'
    },
    recompenseFilleul4: {
        required: 'Vous devez saisir un montant.'
    },
    recompenseParrain0: {
        required: 'Vous devez saisir un montant.'
    },
    recompenseParrain1: {
        required: 'Vous devez saisir un montant.'
    },
    recompenseParrain2: {
        required: 'Vous devez saisir un montant.'
    },
    recompenseParrain3: {
        required: 'Vous devez saisir un montant.'
    },
    recompenseParrain4: {
        required: 'Vous devez saisir un montant.'
    },
    trigger: {
        required: 'Vous devez sélectionner un type de déclencheur.'
    },
    trigger_pro: {
        required: 'Vous devez sélectionner un type de déclencheur.'
    },
    project_type: {
        required: 'Vous devez sélectionner un type de projet.'
    },
    categorie_mandat: {
        required: 'Vous devez sélectionner une catégorie.'
    },
    optin_sponsor: {
        required: 'Vous devez cocher un des champs.'
    },
    iban: {
        required: 'Veuillez renseigner votre iban.'
    },
    bic: {
        required: 'Veuillez renseigner votre bic.'
    },
    rib: {
        required: 'Veuillez renseigner votre rib.'
    },
    kbis: {
        required: 'Veuillez renseigner votre kbis.'
    },
}
